function PlaceIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <g clipPath="url(#clip0_53_292)">
      <path d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z" fill="#BFC6FA"/>
      <path d="M15 15.4285C14.1161 15.4285 13.3928 14.7342 13.3928 13.8857C13.3928 13.0371 14.1161 12.3428 15 12.3428C15.8839 12.3428 16.6071 13.0371 16.6071 13.8857C16.6071 14.7342 15.8839 15.4285 15 15.4285ZM19.8214 14.0399C19.8214 11.2397 17.6919 9.25709 15 9.25709C12.308 9.25709 10.1786 11.2397 10.1786 14.0399C10.1786 15.8451 11.7455 18.2365 15 21.0908C18.2544 18.2365 19.8214 15.8451 19.8214 14.0399ZM15 7.71423C18.375 7.71423 21.4286 10.1982 21.4286 14.0399C21.4286 16.6011 19.283 19.6328 15 23.1428C10.7169 19.6328 8.57141 16.6011 8.57141 14.0399C8.57141 10.1982 11.625 7.71423 15 7.71423Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_53_292">
        <rect width="30" height="30" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  )
}

export default PlaceIcon